/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */

export const colors = {
  white: '#FFFFFF',
  black: '#161616',
  hawkesBlue: '#EEF5FE',
  lightBlue: '#F6F8FB', // was #ECF6FE
  blue: '#1588f9', // For all links
  blue2: '#36A1FF', // If link on dark blue surface
  blueRibbon: '#0051fe', // bitvavo
  veniceBlue: '#0a4981', // For all titles, hover colour for the buttons
  darkBlue: '#0a355a', // For text
  purpleHeart: '#5741d8', // kraken
  green: '#3AB047',
  jade: '#00b678',
  lightGreen: '#90ee90',
  lightGray: '#EFEFEF',
  porcelain: '#E4E8EA',
  mercury: '#E2E2E2',
  beige: '#B7B7B7',
  gray: '#acb6c1',
  shuttleGray: '#5E6D7D',
  boulder: '#787878',
  // it's applied
  orange: '#D6441A',
  red: '#E73324',
  lightRed: '#da0000',
  flamingo: '#f56b35',
} as const;

export type ColorName = keyof typeof colors;
export type ColorValue = typeof colors[ColorName];
